import React from 'react';
import { useHistory } from 'react-router-dom';

import { SettingItem } from './SettingItem';

interface SettingsProps {
    availableSettings: SettingItem[];
}

function Settings({ availableSettings }: SettingsProps): JSX.Element {
    const history = useHistory();

    function redirect(path: string) {
        history.push(path);
    }

    return (
        <div className="settings">
            {availableSettings.map((setting) => {
                return (
                    <div
                        role="button"
                        tabIndex={0}
                        className="setting"
                        key={setting.name}
                        onClick={() => redirect(setting.path)}
                        onKeyDown={() => redirect(setting.path)}
                    >
                        <div className="setting-background">
                            <div>
                                <i className={setting.icon} />
                            </div>
                        </div>
                        <div className="setting-details">
                            <div className="setting-details-title">{setting.name}</div>
                            <div className="setting-details-desc">{setting.description}</div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default Settings;
